<template>
  <div>
    <span v-if="labelTop" class="lp-toggle-label font-weight-medium">
      {{ labelTop }}
      <span v-if="!preview && required" class="text-blue">*</span>
    </span>
    <span
      v-if="preview"
      class="lp-toggle lp-toggle-preview"
      :data-ua-unique-id="dataUaUniqueId"
    >
      {{ modelValue }}
    </span>
    <div
      v-else
      class="lp-toggle"
      :data-ua-unique-id="dataUaUniqueId"
      tabindex="0"
      :class="{ 'lp-toggle-round': round }"
      @keyup.left.prevent="selectPrev"
      @keyup.right.prevent="selectNext"
    >
      <label
        v-for="(option, i) in options"
        :key="i"
        class="lp-toggle-value"
        :class="{
          'lp-toggle-value-selected': option === modelValue,
        }"
        @click="selectValue(i)"
      >
        <span v-if="!icons">{{ option }}</span>
        <lp-icon v-else :name="String(option)" />
      </label>
      <div
        class="lp-toggle-slider"
        :style="{
          width: width + '%',
          transform: `translateX(${sliderPosition}%)`,
          opacity,
        }"
      ></div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref } from 'vue'
import LpIcon from '@/components/icon'

export default defineComponent({
  name: 'lp-toggle',
  components: {
    LpIcon,
  },
  props: {
    options: {
      type: Array as PropType<(string | number | boolean)[]>,
      default: () => [],
    },
    round: Boolean,
    icons: Boolean,
    modelValue: {
      type: [String, Number],
      required: true,
    },
    dataUaUniqueId: {
      type: String,
      default: 'unique-toggle',
    },
    preview: Boolean,
    required: Boolean,
    labelTop: {
      type: String,
      required: false,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const activeIndex = ref(0)

    function selectValue(i: number) {
      activeIndex.value = i
      emit('update:modelValue', props.options[i])
    }

    function selectNext() {
      if (!props.options[activeIndex.value + 1]) {
        selectValue(0)
        return
      }

      selectValue(activeIndex.value + 1)
    }

    function selectPrev() {
      if (!props.options[activeIndex.value - 1]) {
        selectValue(props.options.length - 1)
        // selectNext(0)
        return
      }

      selectValue(activeIndex.value - 1)
    }

    const width = computed(() => (100 / props.options.length).toFixed(2))
    const opacity = computed(() =>
      props.options.includes(props.modelValue) ? 1 : 0,
    )
    const sliderPosition = computed(() => {
      const pos = props.options.findIndex((v) => v === props.modelValue)
      return (pos === -1 ? 0 : pos) * 100
    })

    return {
      selectValue,
      selectNext,
      selectPrev,
      width,
      sliderPosition,
      opacity,
    }
  },
})
</script>
